import { html, nothing, TemplateResult } from 'lit'
import type { InfoIconPosition, ProductSpecificationItem } from 'components/discovery/pdp/product-specifications/typing/product-specifications.js'


export function renderTableLayout(items: ProductSpecificationItem[], infoIconPosition: InfoIconPosition = 'prefix'): TemplateResult {
  return html`
    <cse-definition-list>
      ${items.map((item) => html`
        <cse-definition-list-item info-icon-position="${infoIconPosition}">
          ${item.name}
          ${item.description ? html`<span slot="info">${item.description}</span>` : nothing}
          ${item.property_description ? html`<span slot="description-info">${item.property_description}</span>` : nothing}
          <span slot="description">
            ${item.value}${item.uom ? ` ${item.uom}` : ''}
          </span>
        </cse-definition-list-item>
      `)}
    </cse-definition-list>
  `
}
